// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCykEmFDJ-STly62DqDqmIm-hXMticNlPI",
    authDomain: "herramientasvortex.firebaseapp.com",
    databaseURL: "https://herramientasvortex-default-rtdb.firebaseio.com",
    projectId: "herramientasvortex",
    storageBucket: "herramientasvortex.firebasestorage.app",
    messagingSenderId: "742720564815",
    appId: "1:742720564815:web:614b074495e5b87590843a",
    measurementId: "G-TPR6F8DQ56"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };